import { render, staticRenderFns } from "./LlContactList.vue?vue&type=template&id=15d72e0d"
import script from "./LlContactList.vue?vue&type=script&lang=js"
export * from "./LlContactList.vue?vue&type=script&lang=js"
import style0 from "./LlContactList.vue?vue&type=style&index=0&id=15d72e0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports